/**
 * @description
 * Renders a bootstrap navigation item containing a <NavLink /> from React Router v4 that will highlight the link if the route is active
 */
import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

function NavItem({ to, title }) {
  return (
    <li className="nav-item">
      <NavLink className="nav-link" to={to}>
        {title}
      </NavLink>
    </li>
  );
}

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default NavItem;



// WEBPACK FOOTER //
// ./src/Shared/Nav/NavItem.js